import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { SolarProvider } from '@solar-icons/react/lib/SolarProvider';

// The shared design system (@argus/ui): the tokens + base (globals.css also loads the
// self-hosted Manrope / JetBrains Mono variable fonts, design-system.md §3), the primitive
// classes and the F-30/F-31 extensions — the SAME files apps/web loads, so the portal cannot
// drift from the firm app (PO ruling 2026-10-05). date-picker.css is not loaded: the portal
// renders no DatePicker.
import '@argus/ui/styles/globals.css';
import '@argus/ui/styles/primitives.css';
import '@argus/ui/styles/primitives-ext.css';

import { App } from './App.tsx';
import { initTheme } from './lib/theme.ts';
import './styles.css';

// Paint the stored theme preference before the first render (design-system.md §2.5).
initTheme();

const root = document.getElementById('root');
if (root) {
  // The same Solar icon defaults as apps/web/src/main.tsx, mirrored on `:root` in the shared
  // globals.css. The shared states (empty / error / notice) draw Solar Bold Duotone
  // illustrations, so the second tone is live here exactly as in the firm app.
  createRoot(root).render(
    <StrictMode>
      <SolarProvider
        size={16}
        strokeWidth={1.5}
        secondaryColor="var(--argus-icon-secondary)"
        secondaryOpacity={1}
      >
        <App />
      </SolarProvider>
    </StrictMode>,
  );
}
